import styled from 'styled-components';

export default styled.div`
  &.psn {
    .ecr-success-header {
      li {
        align-items: flex-start;
        min-height: unset;
      }
      .right-part {
        li {
          align-items: center;
          h4 {
            margin-bottom: 0;
          }
        }
      }
    }
  }
`;
